import Loader from "components/Loader";
import useAxios from "hooks/useAxios";
import React, { useEffect, useState } from "react";
import ReactStrapTable from "components/reactStrapTable";
import { cellRendererCheck } from "utils/columns";
import { cloneDeep } from "lodash";



let initialValues = {
    currentPage: 1,
    pageSize: 10,
    order: "desc",
    orderBy: "ModifiedDate",
    filters: [],
    AccumulatorID: 0
};
const GCNHyperLink = (props) => {
    debugger
    const { orgId, gcndata } = props;

    const API = useAxios();
    const [gcntableData, setGcnTableData] = useState([]);
    const [gcnTotalRecords, setGcnTptalRecords] = useState(0);
    const [ndcloading, setNDCLoading] = useState(false);
    useEffect(() => {
        initialValues = {
            currentPage: 1,
            pageSize: 10,
            order: "desc",
            orderBy: "ModifiedDate",
            filters: [],
            AccumulatorID: 0
        };
        fetchGCNDetails(gcndata)
    }, [gcndata])

    let mainCol1 = [
        {
            dataField: "edit",
            text: "Options",
            // cellRenderer: (rowData) => cellRenderEdit(rowData),
            width: 90,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true,
        },
        {
            dataField: "ndc",
            text: "NDC",
            sort: false,
            width: 80,
            show: true,
            inputType: "text",
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.ndc),
        },
        {
            dataField: "drugName",
            text: "NDC Description",
            sort: false,
            width: 160,
            show: true,
            inputType: "text",
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.drugDescription),
        },
        {
            dataField: "packageSize",
            text: "Package Size",
            sort: false,
            width: 120,
            show: true,
            inputType: "number",
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.packageSize),
        },

    ];

    const onHandleNDCPageChange = (filter, hasColFilter, colChangedFilter) => {
        debugger;
        initialValues.currentPage = cloneDeep(filter.currentPage);
        if (hasColFilter) {
            const colFilterOn = { ...filter, filters: colChangedFilter };
            onNDCPageChange(colFilterOn, true);
        } else {
            onNDCPageChange(initialValues);
        }
    };
    const onNDCPageChange = (filter, haveColFilter) => {
        debugger;
        if (haveColFilter) {
            const filterObj = cloneDeep(initialValues);
            filterObj.filters = [...filterObj.filters, ...filter.filters];
            filterObj.currentPage = filter.currentPage;
            filterObj.pageSize = filter.pageSize;
            debugger;
            fetchGCNDetails(gcndata);
        } else {
            debugger;
            fetchGCNDetails(gcndata);
        }
    };
    const onNDCSearchColumnFilters = async (columnFilters) => {
        debugger;
        const filterObj = cloneDeep(initialValues);
        if (columnFilters && columnFilters.length > 0) {
            // filterObj.filters = [...filterObj.filters, ...columnFilters];
            filterObj.filters = [...columnFilters];
        }
        debugger;
        initialValues = cloneDeep(filterObj);
        initialValues.currentPage = 1;
        filterObj.currentPage = 1;
        await fetchGCNDetails(gcndata);
    };




    const handleNDCFilterCancel = () => {
        debugger;
        initialValues = {
            currentPage: 1,
            pageSize: 10,
            order: "desc",
            orderBy: "ModifiedDate",
            filters: [],
            AccumulatorID: 0
        };
        fetchGCNDetails(gcndata);
    };
    const fetchGCNDetails = async (row) => {
        debugger;
        setNDCLoading(true);
        try {
            const { data } = await API.post(
                `SBTenant/${orgId.tenantID}/CrossWalk/GCNHistoryByGCN/${row?.gcnSequenceNumber}`,
                initialValues,
                {
                    hasDefaultURL: true,
                }
            );
            if (data?.items?.length > 0) {
                setGcnTableData(data.items);
                setGcnTptalRecords(data.totalRecords);
            }
            else {
                setGcnTableData([]);
                setGcnTptalRecords(0);
            }
            setNDCLoading(false);
        } catch {
            setNDCLoading(false);
        }
    };

    return (
        <div>
            {/* <h5 className="f-16 text-primary font-weight-700">
              NDC Details
            </h5> */}
            {/* <hr /> */}
            {ndcloading && <Loader opacity={0.1} />}
            <div
                className="table-card scroll-table position-relative border-0 rounded pt-0"
                fixed-height={
                    gcntableData?.length > 0
                        ? "fixed-height"
                        : "default"
                }
            >
                <ReactStrapTable
                    id="crosswalk-auto-ndcdetails"
                    height={550}
                    fixedColumn
                    width={1400}
                    // reset={reset}
                    hasPagination
                    data={gcntableData}
                    columns={mainCol1}
                    display={true}
                    //onExport={handleExport}
                    filters={[]}
                    totalRecords={gcnTotalRecords}
                    pageSize={initialValues.pageSize}
                    currentPage={initialValues.currentPage}
                    //  handleSort={onHandleSort}
                    onPageChange={onHandleNDCPageChange}
                    //onPageSizeChange={onPageSizeChange}
                    onFilterCancel={handleNDCFilterCancel}
                    onSearchColumnFilters={onNDCSearchColumnFilters}
                //accuntErr={accuntErr}
                //collapseSider={collapseSider}
                //toggleSider={toggleSider}

                // showtoggle={true}
                //resetFilterFlag={resetFilterFlag}
                //SetResetFilterFlag={SetResetFilterFlag}
                />
            </div>



        </div>


    )
}
export default GCNHyperLink;